import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';

class DatasetTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'datasetTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<NamedDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}
}

export default new DatasetTableService();
